import { useEffect, useState } from "react";
import axios from "axios";
import { API } from "@/App";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { RotateCcw } from "lucide-react";

export default function Departed() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const nav = useNavigate();

  const load = () => {
    setLoading(true);
    axios.get(`${API}/members`, { params: { status: "departed" }})
      .then(r => setRows(r.data)).finally(() => setLoading(false));
  };
  useEffect(load, []);

  const restore = async (id, e) => {
    e.stopPropagation();
    try {
      await axios.post(`${API}/members/${id}/restore`);
      toast.success("Ortak listesine geri alındı");
      load();
    } catch { toast.error("İşlem başarısız"); }
  };

  return (
    <div className="space-y-6">
      <div>
        <div className="text-xs font-bold uppercase tracking-[0.14em] text-slate-500 mb-2">Arşiv</div>
        <h1 className="text-3xl font-extrabold tracking-tight text-slate-900">Ayrılan Ortaklar</h1>
      </div>

      <div className="crisp-card overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead className="bg-slate-50 border-b border-slate-200 text-[11px] uppercase tracking-wider text-slate-500 font-bold text-left">
              <tr>
                <th className="px-4 py-3">Ad Soyad</th>
                <th className="px-4 py-3">Ayrılış Tarihi</th>
                <th className="px-4 py-3">Devir Edilen Kişi</th>
                <th className="px-4 py-3">YK Karar No</th>
                <th className="px-4 py-3">Hisseler</th>
                <th className="px-4 py-3"></th>
              </tr>
            </thead>
            <tbody>
              {loading && <tr><td colSpan={6} className="px-4 py-10 text-center text-slate-500">Yükleniyor...</td></tr>}
              {!loading && rows.length === 0 && <tr><td colSpan={6} className="px-4 py-10 text-center text-slate-500">Ayrılan ortak yok.</td></tr>}
              {!loading && rows.map((m, i) => (
                <tr key={m.id} data-testid={`departed-row-${m.id}`}
                    onClick={() => nav(`/ortak/${m.id}`)}
                    className="border-b border-slate-100 last:border-0 table-row-hover cursor-pointer stagger-row"
                    style={{ animationDelay: `${Math.min(i,20)*20}ms` }}>
                  <td className="px-4 py-3 font-semibold text-slate-900">{m.ad_soyad}</td>
                  <td className="px-4 py-3 text-slate-600 font-mono-nums">{m.ayrilis_tarihi || "—"}</td>
                  <td className="px-4 py-3 text-slate-600">{m.devir_edilen_kisi || "—"}</td>
                  <td className="px-4 py-3 text-slate-600 font-mono-nums">{m.yonetim_kurulu_karar_no || "—"}</td>
                  <td className="px-4 py-3">
                    <div className="flex flex-wrap gap-1.5">
                      {m.misas_hisse>0 && <span className="company-misas rounded-full px-2 py-0.5 text-[11px] font-bold">MS {m.misas_hisse}</span>}
                      {m.mis_holding_hisse>0 && <span className="company-mh rounded-full px-2 py-0.5 text-[11px] font-bold">MH {m.mis_holding_hisse}</span>}
                      {m.koop_hisse>0 && <span className="company-koop rounded-full px-2 py-0.5 text-[11px] font-bold">KOOP {m.koop_hisse}</span>}
                    </div>
                  </td>
                  <td className="px-4 py-3 text-right">
                    <button data-testid={`restore-${m.id}`} onClick={(e) => restore(m.id, e)}
                            className="inline-flex items-center gap-1.5 text-xs font-semibold text-slate-700 hover:text-slate-900 border border-slate-200 rounded-md px-2.5 py-1.5 bg-white hover:bg-slate-50">
                      <RotateCcw size={13}/> Geri Al
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
